import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t } = useTranslation('common');

  // Helper to render multiline text
  const renderText = (text) => {
    if (!text) return null;
    return text.split('\n').map((para, i) => (
      <p key={i} className="mb-2">{para}</p>
    ));
  };

  const sections = [1,2,3,4,5,6,7,8,9,10,11,12];

  return (
    <>
      <Helmet>
        <title>{t('privacyPolicy.title')} | Hotel Macarios</title>
        <meta name="description" content={t('privacyPolicy.intro')} />
        <link rel="canonical" href="https://www.hotelmacarios.com.mx/privacy-policy" />
      </Helmet>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-2">{t('privacyPolicy.title')}</h1>
        <p className="text-gray-500 mb-8">{t('privacyPolicy.effectiveDate')}</p>
        <div className="text-gray-700 space-y-4">
          <p>{t('privacyPolicy.intro')}</p>
          {sections.map(num => {
            const title = t(`privacyPolicy.section${num}.title`);
            const content = t(`privacyPolicy.section${num}.content`);
            // Only render if content exists
            if (!content) return null;
            return (
              <div key={num}>
                <h2 className="text-xl font-semibold mt-6 mb-2">{title}</h2>
                {renderText(content)}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;